module.exports = __webpack_public_path__ + "static/media/messenger.c6640462.svg";